import * as React from "react";
import type { SVGProps } from "react";
const SvgQuestionMarkCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path
      fill="#0D1B27"
      fillOpacity={0.3}
      d="M1.334 8a6.667 6.667 0 1 1 13.333 0A6.667 6.667 0 0 1 1.334 8m5.521-1.52a1.146 1.146 0 1 1 1.768.962 3.7 3.7 0 0 0-.822.7c-.25.297-.467.698-.467 1.192a.667.667 0 1 0 1.333 0c0-.082.034-.19.157-.337.125-.15.31-.297.525-.437A2.478 2.478 0 0 0 8.001 4a2.48 2.48 0 0 0-2.48 2.48.667.667 0 1 0 1.334 0m1.146 4.187a.667.667 0 0 0 0 1.334.667.667 0 0 0 0-1.334"
    />
  </svg>
);
export default SvgQuestionMarkCircle;
